export default __webpack_public_path__ + "static/BgImg02-2157e55ccc0e7bbca045330e6d83dc71.webp";